import { reject, findIndex, find, concat, map, indexOf } from 'lodash';

import { FETCH_ALL_FILTERS, DELETE_FILTER,
  UPDATE_FILTER, ADD_FILTER, FETCH_FILTER,
  ADD_FILTER_MAPPING, UPDATE_FILTER_MAPPING, DELETE_FILTER_MAPPING,
  UPDATE_FILTER_MAPPING_VALUES, UNMAP_MAPPING_VALUES,
  FETCH_FILTER_OPTIONS, RESET_IS_NEW_FILTER_MAPPING } from './FilterActions';


// Initial State
const initialState = {
  filters: [],
  status: null,
  errors: null,
  meta: [],
  mappingOptions: [],
  searchableFields: [],
};


const FilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_FILTERS:
      return {
        ...state, filters: action.filters, meta: action.meta, status: action.status, errors: action.errors,
      };
    case DELETE_FILTER: {
      const filters = reject(state.filters, { _id: action.id });
      return { ...state, filters };
    }
    case UPDATE_FILTER: {
      const { filters } = state;
      const idx = findIndex(filters, { _id: action.filter._id });
      if (idx >= 0) {
        const newFilters = [...filters];
        newFilters[idx] = { ...filters[idx], ...action.filter };
        return { ...state, filters: newFilters };
      }
      return state;
    }
    case ADD_FILTER: {
      const { filters } = state;
      const newFilters = concat(filters, action.filter);
      return { ...state, filters: newFilters };
    }
    case FETCH_FILTER: {
      const { filters } = state;
      const idx = findIndex(filters, { _id: action.filter._id });
      if (idx >= 0) {
        filters[idx] = action.filter;
      } else {
        filters.push(action.filter);
      }
      return {
        ...state, filters, mappingOptions: action.options || [], searchableFields: action.searchable || [],
      };
    }
    case FETCH_FILTER_OPTIONS: {
      return {
        ...state, mappingOptions: action.options || [],
      };
    }
    case ADD_FILTER_MAPPING: {
      const { filters } = state;
      const idx = findIndex(filters, { _id: action.filterId });
      if (idx >= 0) {
        const mappings = filters[idx].mappings || [];
        const newMappings = [...mappings];
        newMappings.push(action.mapping);
        filters[idx].mappings = newMappings;
      }
      return { ...state, filters };
    }
    case RESET_IS_NEW_FILTER_MAPPING: {
      const { filters } = state;
      const { filterId, mappingIds } = action;
      const idx = findIndex(filters, { _id: filterId });
      if (idx >= 0) {
        const mappings = filters[idx].mappings || [];
        const newMappings = map(mappings, (m) => {
          if (indexOf(mappingIds, m._id) >= 0) {
            return { ...m, is_new: false };
          }
          return { ...m };
        });
        filters[idx].mappings = newMappings;
      }
      return { ...state, filters };
    }
    case UPDATE_FILTER_MAPPING: {
      const { filters } = state;
      const idx = findIndex(filters, { _id: action.filterId });
      if (idx >= 0) {
        const mappings = filters[idx].mappings || [];
        const currentMappingIdx = findIndex(mappings, { _id: action.mapping._id });
        if (currentMappingIdx >= 0) {
          const newMappings = [...mappings];
          newMappings[currentMappingIdx] = action.mapping;
          filters[idx].mappings = newMappings;
        }
      }
      return { ...state, filters };
    }
    case DELETE_FILTER_MAPPING: {
      const { filters } = state;
      const idx = findIndex(filters, { _id: action.filterId });
      if (idx >= 0) {
        const mappings = filters[idx].mappings || [];
        const newMappings = reject(mappings, { _id: action.id });
        filters[idx].mappings = newMappings;
      }
      return { ...state, filters };
    }
    case UNMAP_MAPPING_VALUES:
    case UPDATE_FILTER_MAPPING_VALUES: {
      const { filters } = state;
      const idx = findIndex(filters, { _id: action.filterId });
      if (idx >= 0) {
        filters[idx].mappings = action.mappings;
      }
      return { ...state, filters };
    }
    default:
      return state;
  }
};

/* Selectors */
export const getFilters = state => state.filter.filters;
export const getMeta = state => state.filter.meta;
export const getLoading = state => state.filter.status === 'loading';
export const getLoaded = state => state.filter.status === 'loaded';
export const getHasErrors = state => state.filter.status === 'error';
export const getMappingOptions = state => state.filter.mappingOptions;
export const getSearchableFields = state => state.filter.searchableFields;
export const getErrors = (state) => {
  if (state.filter.status === 'error') {
    return state.filter.errors;
  }
  return null;
};
export const getFilter = (state, id) => {
  const filters = state.filter.filters;
  const f = find(filters, ft => ft._id === id || ft.tag === id);
  return f || {};
};


export default FilterReducer;
